import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
import { getCatalog, getProduct } from '~/entities/catalog/api';
import { productSlug } from '~/entities/catalog/paths';
import { ProductDetailPage } from '~/pages/product-detail';

export const Route = createFileRoute('/products_/$id')({
  // Links pass `product.id`; the URL always carries the dot-free slug.
  params: { stringify: ({ id }) => ({ id: productSlug(id) }) },
  loader: async ({ params, location }) => {
    await getCatalog();
    const product = await getProduct(params.id);
    // A 404 the router renders in the layout (DefaultNotFoundComponent), with the not-found head.
    if (!product) {
      throw notFound();
    }

    // The id or code (`/products/sa214-2.6`, `/products/JA-103K`) still resolves, but only the slug renders the page.
    if (productSlug(product.id) !== params.id) {
      throw redirect({
        to: '/products/$id',
        params: { id: product.id },
        search: location.search,
        hash: location.hash,
        replace: true,
      });
    }

    return { product };
  },
  component: ProductDetailRoute,
});

function ProductDetailRoute() {
  const { id } = Route.useParams();

  return <ProductDetailPage productId={id} />;
}
